import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import axios from 'axios';
export default function DeployInfo() {
  const [deployedAt, setDeployedAt] = useState(null);
  // debugger;
  useEffect(() => {
    axios
      .get('/deploy-info.json') // just like /Logo.png
      .then(res => setDeployedAt(res.data.deployedAt))
      .catch(() => setDeployedAt(null));
  }, []);

  if (!deployedAt) return null;

  return (
    <div className="text-xs text-gray-500 mt-4 text-center">
      Deployed at: {new Date(deployedAt).toLocaleString()}
    </div>
  );
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <DeployInfo />
  </React.StrictMode>
);
